import React, { Component } from 'react';
import { SketchPicker } from 'react-color';

import { allHasSameProp } from 'helpers/Object';
import PropTypes from 'prop-types';

import CanvasMenuDropDown from '../menu/CanvasMenuDropDown';

import './CanvasColor.scss';

export default class CanvasColor extends Component {
  static propTypes = {
    canvasRef: PropTypes.object,
    updateInfo: PropTypes.func
  };

  state = {
    color: null
  };

  updateSelectedColor = () => {
    const { canvasRef } = this.props;
    const activeObjects = canvasRef.getActiveObjects();

    if (activeObjects && activeObjects.length) {
      const hasSameColor = allHasSameProp(
        activeObjects[0].fill,
        'fill',
        activeObjects
      );

      if (hasSameColor) {
        this.setState({ color: activeObjects[0].fill });
      } else {
        this.setState({ color: null });
      }
    }
  };

  handleChangeComplete = (color) => {
    const { canvasRef, updateInfo } = this.props;
    const activeObjects = canvasRef.getActiveObjects();

    activeObjects.forEach((object) => {
      object.set({ fill: color.hex });
    });

    updateInfo();
    canvasRef.renderAll();
  };

  render() {
    const { color } = this.state;

    return (
      <div className="color-menu">
        <CanvasMenuDropDown
          className="text-menu__button--large"
          icon="color-picker"
          toolTip="canvas-editor.color-picker"
          preventCloseOnDropdownListClick={true}
          onClick={this.updateSelectedColor}
        >
          <SketchPicker
            color={color || ''}
            disableAlpha={true}
            onChangeComplete={this.handleChangeComplete}
          />
        </CanvasMenuDropDown>
      </div>
    );
  }
}
